module.exports = __webpack_public_path__ + "static/media/geesaa_6.11daad8c.jpg";